import { useState } from 'react'
import { Button, Form, Modal, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DynamicForm from './DynamicForm';
import MapPicker from '../utils/MapPicker';
import { useNavigate } from 'react-router-dom';
import { regexPatterns } from '../utils/regexUtils';
import { useCatalogs } from '../../hooks/useCatalogs';
import { useCommerceActivity } from '../../hooks/useCommerceActivity';
import React, { useEffect } from "react";
import { saveCommerceStep, getCommerceStep } from "../../services/commerceWizardService";
import { useParams } from "react-router-dom";
import { properties } from '../../utils/Properties_es';

export default function CommerceDataForm({ onValidate, data, updateData }) {
    const { id: idTransaction } = useParams();
    const navigate = useNavigate();
    const [provinceBefore, setProvinceBefore] = useState("");
    const [show, setShow] = useState(false);
    const handleOpen = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setShowCordenada(false);
    };
    const { catalogs } = useCatalogs();
    const { activities } = useCommerceActivity();
    const [showCordenada, setShowCordenada] = useState(false);
    const [coords, setCoords] = useState({ lat: data?.latitude ?? '', lng: data?.longitude ?? '' });
    // Estado de errores
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const validateForm = () => {
        const newErrors = {};

        fieldConfig.flat().forEach(field => {
            if (field.isRequired && !data[field.key]) {
                newErrors[field.key] = properties.general_field_required(field.label);
            }
        });

        // Validación obligatoria de coordenadas
        if (!coords.lat || !coords.lng) {
            newErrors.coords = properties.commerce_error_coords;
        }

        // Validar teléfonos (6-15 caracteres)
        const phoneFields = {
            phoneReceive: properties.commerce_field_receive_phone,
            phone: properties.field_cellphone,
            phoneCommerce: properties.commerce_field_phone
        };
        Object.entries(phoneFields).forEach(([phoneField, fieldLabel]) => {
            if (data[phoneField]) {
                const phoneValue = String(data[phoneField]).trim();
                if (phoneValue.length < 6 || phoneValue.length > 15) {
                    newErrors[phoneField] = `${fieldLabel} debe tener entre 6 y 15 dígitos`;
                }
            }
        });

        // Validar emails
        const emailFields = {
            emailNotifications: properties.commerce_field_email_notifications,
            emailElectronic: properties.commerce_field_email_electronic,
            emailNotificationsContra: properties.commerce_field_email_chargeback
        };
        Object.entries(emailFields).forEach(([emailField, fieldLabel]) => {
            if (data[emailField]) {
                if (!regexPatterns.email.test(data[emailField])) {
                    newErrors[emailField] = `${fieldLabel} no es válido`;
                }
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    //
    const handleSelect = ({ lat, lng }) => {
        setCoords({
            lat: lat ?? '',
            lng: lng ?? ''
        });
        updateData({
            latitude: lat ?? '',
            longitude: lng ?? ''
        });
    }

    const initialForm = {
        name: "",
        activity: "",
        mccId: "",
        province: "",
        canton: "",
        distrito: "",
        barrio: "",
        address: "",
        color: "",
        rotulado: "",
        remodelacion: "",
        locationPoint: "",
        nameReceive: "",
        time: "",
        confirmation: "",
        phoneReceive: "",
        phoneHome: "",
        phone: "",
        phoneCommerce: "",
        emailNotifications: "",
        emailElectronic: "",
        emailNotificationsContra: "",
        commerceSide: "",
        constitutionDate: ""
    }
    const fieldConfig = [
        [
            { key: "name", label: properties.commerce_field_name, type: "text", isRequired: true, regex: regexPatterns.noSpecialChars , maxCaracters: 140},
            { key: "activity", label: properties.commerce_field_activity, type: "select", options: activities?.map(p => ({ key: p.businessName, value: p.businessName  })), isRequired: true }
        ],
        [
            { key: "province", label: properties.field_province, type: "select", options: catalogs.provinces?.map(p => ({ key: p.provinceName, value: p.provinceCode })), isRequired: true },
            { key: "canton", label: properties.field_canton, type: "select", options: catalogs.cantons?.filter(p => p.provinceCode === data.province).map(p => ({ key: p.cantonName, value: p.cantonCode })), isRequired: true, disabled: !data.province }
        ],
        [
            { key: "distrito", label: properties.field_district, type: "select", options: catalogs.district?.filter(p => p.cantonCode === data.canton && p.provinceCode === data.province).map(p => ({ key: p.districtName, value: p.districtCode })), isRequired: true, disabled: !data.canton },
            { key: "barrio", label: properties.field_neighborhood, type: "select", options: catalogs.neighborhoods?.filter(p =>  p.districtCode === data.distrito && p.cantonCode === data.canton &&  p.provinceCode === data.province).map(p => ({ key: p.neighborhoodName, value: p.neighborhoodCode })), isRequired: true, disabled: !data.distrito }
        ],
        [
            { key: "commerceSide", label: properties.commerce_field_side, type: "select", options: [{ key: properties.personal_option_left, value: "IZQ" }, { key: properties.personal_option_right, value: "DER" }], column: "mb-6", isRequired: true, },
            { key: "constitutionDate", label: properties.commerce_field_constitution_date, type: "date", isDivider: true, isRequired: true }
        ],
        [
            { key: "address", label: properties.commerce_field_address, type: "text", isRequired: true, maxCaracters: 90 }
        ],
        [
            { key: "color", label: properties.commerce_field_color, type: "text", isRequired: true, regex: regexPatterns.onlyLetters, maxCaracters: 20 },
            { key: "rotulado", label: properties.commerce_field_signage, type: "radio", options: [{ key: properties.commerce_option_no_signage, value: "no" }, { key: properties.commerce_option_yes_signage, value: "si" }], isRequired: true },
            { key: "empty", type: "empty" },
            { key: "remodelacion", label: properties.commerce_field_remodeling, type: "radio", isDivider: true, options: [{ key: properties.commerce_option_no_remodeling, value: "no" }, { key: properties.commerce_option_yes_remodeling, value: "si" }], isRequired: true }
        ],
        [
            { key: "nameReceive", label: properties.commerce_field_receive_name, type: "text", isRequired: true, regex: regexPatterns.onlyLetters, maxCaracters: 240 },
            { key: "time", label: properties.commerce_field_receive_time, type: "text", isRequired: true }
        ],
        [
            { key: "phoneReceive", label: properties.commerce_field_receive_phone, type: "text", isRequired: true, regex: regexPatterns.onlyNumbers , maxCaracters: 8},
            { key: "confirmation", label: properties.commerce_field_confirmation, type: "radio", isDivider: true, options: [{ key: properties.general_no, value: "no" }, { key: properties.general_yes, value: "si" }], isRequired: true }
        ],
        [
            { key: "phone", label: properties.commerce_field_cellphone, type: "text", isRequired: true, regex: regexPatterns.onlyNumbers, maxCaracters: 8 },
            { key: "phoneCommerce", label: properties.commerce_field_phone, type: "text", regex: regexPatterns.onlyNumbers, isRequired: true, maxCaracters: 8 }
        ],
        [
            { key: "emailNotifications", label: properties.commerce_field_email_notifications, type: "email", isRequired: true, maxCaracters: 40 },
            { key: "emailElectronic", label: properties.commerce_field_email_electronic, type: "email", isRequired: true, maxCaracters: 40 }
        ],
        [
            { key: "emailNotificationsContra", label: properties.commerce_field_email_chargeback, type: "email", isIconInformation: true, column: "mb-6", isRequired: true, infoTils: properties.commerce_chargeback_info, maxCaracters: 40 },
            { key: "empty", type: "empty" }
        ]
    ]
    const handleChange = (e) => {
        const { name, value, selectedIndex, options } = e.target;
        const selectedText = options ? options[selectedIndex]?.text : "";
        const locationFields = ["province", "canton", "distrito", "barrio"];

        if (name === "activity") {
            const selectedActivity = activities?.find((item) => item.businessName === value);
            updateData({
                activity: value,
                mccId: selectedActivity?.id ?? ""
            });
            return;
        }

        // Reiniciar cantón/distrito/barrio si cambia provincia
        if (provinceBefore !== "" && provinceBefore !== value && name === "province") {
            updateData({ canton: "" });
            updateData({ distrito: "" });
            updateData({ barrio: "" });
        }
        // Actualizar provinceBefore con el nuevo valor de la provincia
        setProvinceBefore(value);
        updateData({ [name]: value });

        if (locationFields.includes(name)) {
            updateData({
                [name]: value,
                [`${name}Name`]: selectedText // Esto crea provinceName, cantonName, etc.
            });
        }
    };

    // RESETEAR FORMULARIO
    const handleReset = () => {
        updateData(initialForm);
        setShow(false);
        onValidate(false);
    };

    const handleContinue = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            await saveCommerceStep({
                idTransaction,
                data,
                coords,
            });
            onValidate(true);
            navigate(`/forms/${idTransaction}/files`);
        } catch (error) {
            console.error(error);
            alert(properties.commerce_error_save);
        }
    };
    //VALIDA SI TIENE INFO ANTERIOR
    useEffect(() => {
        async function loadInitialData() {
            setIsLoading(true);
            try {
                const commerce = await getCommerceStep(idTransaction);
                if (!commerce) return;
                updateData({
                    ...data,
                    name: commerce.tradeName ?? "",
                    mccId: commerce.mccId ?? "",
                    activity: commerce.businessActivity ?? "",
                    province: String(commerce.provinceId ?? ""),
                    canton: String(commerce.cantonId ?? ""),
                    distrito: String(commerce.districtId ?? ""),
                    barrio: String(commerce.neighborhoodCode ?? ""),
                    address: commerce.address ?? "",
                    remodelacion: commerce.remodeling ? "si" : "no",
                    locationPoint: commerce.permanentAddress ? "si" : "no",
                    color: commerce.color ?? "",
                    rotulado: commerce.wazeName ?? "",
                    phone: commerce.mobilePhoneExt ?? "",
                    phoneCommerce: commerce.workPhoneExt ?? "",
                    emailElectronic: commerce.email ?? "",
                    emailNotifications: commerce.otherEmail ?? "",
                    emailNotificationsContra: commerce.chargebackEmail ?? "",
                    nameReceive: commerce.recipientPerson ?? "",
                    phoneReceive: commerce.recipientPhone ?? "",
                    time: commerce.schedule ?? "",
                    confirmation: commerce.requireConfirmAppointment ? "si" : "no",
                    latitude: commerce.latitude ?? '',
                    longitude: commerce.longitude ?? '',
                    commerceSide: commerce.commerceSide ?? "",
                    constitutionDate: formatToInput(commerce.constitutionDate ?? ""),
                    provinceName: findLabel(catalogs.provinces, commerce.provinceId, 'provinceName'),
                    cantonName: findLabel(catalogs.cantons, commerce.cantonId, 'cantonName'),
                    distritoName: findLabel(catalogs.district, commerce.districtId, 'districtName'),
                    barrioName: findLabel(catalogs.neighborhoods, commerce.neighborhoodCode, 'neighborhoodName')
                });
                setCoords({
                    lat: commerce.latitude ?? '',
                    lng: commerce.longitude ?? ''
                }); 
                setProvinceBefore(String(commerce.provinceId ?? ""));
            } catch (error) {
                console.error("Error cargando datos:", error);
            } finally {
                setIsLoading(false);
            }
        }

        loadInitialData();
    }, []);

    const findLabel = (list, id, labelKey) => {
        const item = list?.find(i => String(i.id || i.provinceId || i.cantonId || i.districtId || i.neighborhoodCode) === String(id));
        return item ? item[labelKey] : "";
    };


    const formatToInput = (dateString) => {
        if (!dateString) return "";


        const [date] = dateString.split(" ");
        return date;
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{properties.commerce_loading}</span>
                </div>
            </div>
        );
    }
    return (
        <>
            <Form>
                <div className='px-4 mx-2 div-divider pb-4'>
                    <div className='d-flex flex-column gap-1'>
                        <h5 className='fw-bold'>{properties.commerce_title}</h5>
                        <span className='fw-bold'>{properties.general_required_fields}</span>
                    </div>
                    <DynamicForm fieldConfig={fieldConfig} formData={data} handleChange={handleChange} errors={errors} />
                    <Row className='pb-5 mb-5 form-actions-row'>
                    <div className='d-flex justify-content-between px-0 form-actions'>
                            <Button
                                variant="outline-primary"
                                className="rounded-0 form-action-btn"
                                onClick={() => setShowCordenada(true)}
                            >
                                {properties.commerce_btn_location}
                            </Button>

                            {errors.coords && (
                                <div className="text-danger mt-2">
                                    {errors.coords}
                                </div>
                            )}
                        </div>
                    </Row>
                </div>
                <Row className='pb-5 mb-5 form-actions-row'>
                    <div className='d-flex justify-content-between px-0 form-actions'>
                        <Button size='sm' variant='outline-primary' className='px-2 py-2 shadow rounded-0 btn-icon-text' onClick={handleOpen}>
                            <i className='bi bi-trash'></i> {properties.btn_clean_fields}
                        </Button>
                        <div className='d-flex gap-3 form-actions-group'>
                            <Button variant='outline-primary' size='sm' className='px-5 py-2 shadow rounded-0 form-action-btn'
                                as={Link}
                                to={`/forms/${idTransaction}/personal`}>
                                {properties.btn_back}
                            </Button>
                            <Button variant='primary' size='sm' className='px-5 py-2 shadow rounded-0 form-action-btn'
                                onClick={handleContinue}>
                                {properties.btn_continue}
                            </Button>
                        </div>
                    </div>
                </Row>
            </Form>
            <Modal show={show} onHide={handleClose} centered size='md'>
                <Modal.Header closeButton className='border-bottom-0 px-5 pt-5 pb-0'>
                    <Modal.Title className='fs-6 text-center d-flex justify-content-center align-items-center w-100'><strong>{properties.modal_clean_title}</strong></Modal.Title>
                </Modal.Header>
                <Modal.Body className='px-5 mx-5 mb-5 fs-6 pt-0'>
                    <div className='d-flex flex-column justify-content-center w-100 pb-3 gap-4 align-items-center'>
                        <span>{properties.modal_clean_warning} </span>
                        <div className='d-flex gap-3'>
                            <Button variant='outline-primary' className='rounded-0' onClick={handleClose}>
                                {properties.btn_keep_fields}
                            </Button>
                            <Button variant='danger' className='rounded-0' onClick={handleReset}>
                                {properties.btn_delete_fields}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showCordenada} onHide={handleClose} centered size='lg' backdrop="static" keyboard={false}>
                <Modal.Header closeButton className='border-bottom-0 px-5 pb-0 mt-2'>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-column gap-4 px-5'>
                        <div className='d-flex gap-4'>
                            <div className='text-light bg-danger d-flex justify-content-center  fs-4 rounded-circle' style={{ width: "50px", height: "50px" }}>
                                <strong className=' d-flex justify-content-center align-items-center'>1</strong>
                            </div>
                            <div className='d-flex flex-column gap-0 pt-3'>
                                <span><strong>{properties.commerce_map_instruction}</strong> {properties.commerce_map_detail}</span>
                                <div className='d-flex flex-column pt-3'>
                                    <strong>{properties.commerce_map_example}</strong>
                                    <MapPicker onSelect={handleSelect} />
                                </div>
                            </div>
                        </div>
                        <div className='mx-auto'>
                            <Form>
                                <Form.Group>
                                    <Row className='w-100 d-flex'>
                                        <Col md={6}>
                                            <Form.Label className='fs-6'>{properties.commerce_coord_x}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder={properties.commerce_coord_x}
                                                name="coordenada-x"
                                                value={coords.lat}
                                                className='rounded-0'
                                                readOnly>
                                            </Form.Control>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Label className='fs-6'>{properties.commerce_coord_y}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder={properties.commerce_coord_y}
                                                name="coordenada-y"
                                                value={coords.lng}
                                                className='rounded-0'
                                                readOnly>
                                            </Form.Control>
                                        </Col>
                                    </Row>
                                </Form.Group>

                            </Form>
                        </div>

                        <Row className='mx-auto w-100'>
                            <Col md={2}></Col>
                            <Col md={8} className='d-flex justify-content-end'>
                                <Button variant='primary' size='md' className='px-5 py-2 shadow rounded-0' onClick={handleClose} disabled={!coords.lat}>
                                    {properties.btn_done}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}